import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { GoldMindsLogo } from 'src/images';

interface LoadingScreenProps {
  message?: string;
}

export default function LoadingScreen({ message = 'Loading...' }: LoadingScreenProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#FAFAFA',
        gap: 3,
      }}
    >
      <Box
        component="img"
        src={GoldMindsLogo}
        alt="Gold Minds Logo"
        sx={{
          width: 120,
          height: 120,
          objectFit: 'contain',
        }}
      />
      
      <CircularProgress 
        size={40}
        sx={{
          color: '#297041',
        }}
      />
      
      <Typography
        variant="body1"
        sx={{
          color: '#718096',
          fontSize: '16px',
          fontWeight: 500,
        }}
      >
        {message}
      </Typography>
    </Box>
  );
}